import OperationType from '@/enums/OperationType';
import CollectionMethods from '@general/js/enums/CollectionMethodsEnum';
import cloneDeep from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';

export const mapPremiumPaymentMethod = (collectionMethodInformation, initialCollectionMethodInformation) => {
  const paymentMethodInformationObj = cloneDeep(collectionMethodInformation);
  const initialData = cloneDeep(initialCollectionMethodInformation);

  // this if makes sure paymentMethodInformationObj is not null
  if (paymentMethodInformationObj) {
    if (!isEqual(paymentMethodInformationObj, initialData)) {
      paymentMethodInformationObj.op = OperationType.REPLACE;
    } else {
      paymentMethodInformationObj.op = OperationType.NONE;
    }
  }
  return paymentMethodInformationObj;
};

export const mapPremiumPaymentAccount = (premiumPaymentInformation, initialPremiumPaymentInformation, isBillToDd) => {
  const paymentInformationObj = cloneDeep(premiumPaymentInformation);
  const initialData = cloneDeep(initialPremiumPaymentInformation);

  // this if makes sure paymentInformationObj is not null
  if (paymentInformationObj) {
    if (!isEqual(paymentInformationObj, initialData)) {
      if (isBillToDd) {
        // op:add is required when changing from BILL -> DD
        paymentInformationObj.op = OperationType.ADD;
      } else {
        paymentInformationObj.op = OperationType.REPLACE;
      }
    } else {
      paymentInformationObj.op = OperationType.NONE;
    }
  }

  return paymentInformationObj;
};

export const mapClaimsAccount = (claimsAccountInformation, initialClaimsAccountInformation) => {
  const claimsAccountObj = cloneDeep(claimsAccountInformation);
  const initialData = cloneDeep(initialClaimsAccountInformation);

  // if initialData is not null
  if (initialData) {
    // need to add extra properties for correct comparison (`directDebitAgreement` property only exists in the update accounts request payload but not in retrieve accounts response payload)
    initialData.directDebitAgreement = claimsAccountObj.directDebitAgreement;
  }

  // this if makes sure claimsAccountObj is not null
  if (claimsAccountObj) {
    if (initialData === null) {
      // If initially there is no claimsAccount, `op` will be `add`
      claimsAccountObj.op = OperationType.ADD;
    } else if (!isEqual(claimsAccountObj, initialData)) {
      claimsAccountObj.op = OperationType.REPLACE;
    } else {
      claimsAccountObj.op = OperationType.NONE;
    }
  }

  return claimsAccountObj;
};

/**
 *
 * @param {Object} newPremiumPaymentMethod New premiumPaymentMethod object which has new collectionMethod that is being updated to
 * @param {Object} initialPremiumPaymentMethod Old premiumPaymentMethod object which has old collectionMethod that is being moved from
 *
 * @returns {Boolean} true if collectionMethod is moving from BILL -> DD, false otherwise
 */
const isMethodChangingFromBillToDD = (newPremiumPaymentMethod, initialPremiumPaymentMethod) => {
  if (
    initialPremiumPaymentMethod &&
    initialPremiumPaymentMethod.collectionMethod === CollectionMethods.INVOICE &&
    newPremiumPaymentMethod &&
    newPremiumPaymentMethod.collectionMethod === CollectionMethods.DIRECT_DEBIT
  ) {
    return true;
  }
  return false;
};

export const createUpdatedPaymentDetailsObj = (paymentDetails, initialPaymentDetails) => {
  const paymentDetailsObj = {};

  // fill in paymentDetails object
  paymentDetailsObj.premiumPaymentMethod = mapPremiumPaymentMethod(paymentDetails.premiumPaymentMethod, initialPaymentDetails.premiumPaymentMethod);
  paymentDetailsObj.premiumPaymentAccount = mapPremiumPaymentAccount(
    paymentDetails.premiumPaymentAccount,
    initialPaymentDetails.premiumPaymentAccount,
    isMethodChangingFromBillToDD(paymentDetails.premiumPaymentMethod, initialPaymentDetails.premiumPaymentMethod),
  );

  paymentDetailsObj.claimsAccount = mapClaimsAccount(paymentDetails.claimsAccount, initialPaymentDetails.claimsAccount);

  // Set startDate value to null if empty
  if (paymentDetailsObj.premiumPaymentMethod?.paymentStartDate === '') {
    paymentDetailsObj.premiumPaymentMethod.paymentStartDate = null;
  }

  return paymentDetailsObj;
};
